{
  "journalAudit.action.comparison.reviewed": "Comparaison de réponses décidée",
  "journalAudit.action.source.reindex_requested": "Relance de l’indexation d’une source demandée",
  "v4.sources.classement.couleur": "Couleur",
  "v4.sources.classement.couleur_amber": "Ambre",
  "v4.sources.classement.couleur_blue": "Bleu",
  "v4.sources.classement.couleur_emerald": "Émeraude",
  "v4.sources.classement.couleur_pink": "Rose",
  "v4.sources.classement.couleur_red": "Rouge",
  "v4.sources.classement.couleur_slate": "Ardoise",
  "v4.sources.classement.couleur_violet": "Violet",
  "v4.sources.classement.creation_echec": "La création a échoué.",
  "v4.sources.classement.cree": "Créé.",
  "v4.sources.classement.creer_composant": "Créer la rubrique",
  "v4.sources.classement.creer_etiquette": "Créer l’étiquette",
  "v4.sources.classement.creer_version": "Créer la version cible",
  "v4.sources.classement.date_prevue": "Date prévue",
  "v4.sources.classement.etiquettes": "Étiquettes",
  "v4.sources.classement.livree": "Livrée",
  "v4.sources.classement.nom_composant": "Nom de la nouvelle rubrique",
  "v4.sources.classement.nom_deja_pris": "Ce nom est déjà pris dans cette liste.",
  "v4.sources.classement.nom_etiquette": "Nom de la nouvelle étiquette",
  "v4.sources.classement.nom_obligatoire": "Le nom est obligatoire.",
  "v4.sources.classement.nom_version": "Nom de la nouvelle version cible",
  "v4.sources.classement.nombre": "{{n}} au total",
  "v4.sources.classement.non_livree": "Non livrée",
  "v4.sources.classement.retour": "Éléments du projet",
  "v4.sources.classement.rubriques": "Rubriques",
  "v4.sources.classement.titre": "Classement du produit",
  "v4.sources.classement.versions": "Versions cibles",
  "v4.sources.classement.vide_etiquettes": "Aucune étiquette.",
  "v4.sources.classement.vide_rubriques": "Aucune rubrique.",
  "v4.sources.classement.vide_versions": "Aucune version cible.",
  "v4.sources.code.AI_KILL_SWITCH_ACTIVE": "L’IA est arrêtée : le geste ne peut pas être fait maintenant.",
  "v4.sources.code.ALREADY_REVIEWED": "Cette comparaison a déjà été décidée : la décision vient d’être relue.",
  "v4.sources.code.AMONT_INDEXATION_NON_RELANCABLE": "Seule une indexation en échec se relance : cette source est indexée ou son indexation est en cours.",
  "v4.sources.code.COMPARISON_NOT_RETRYABLE": "Seule une comparaison en échec se relance.",
  "v4.sources.code.COMPARISON_NOT_REVIEWABLE": "Il faut au moins deux réponses complètes et exploitables avant de décider.",
  "v4.sources.code.CORE_UNAVAILABLE": "L’IA est arrêtée : le geste ne peut pas être fait maintenant.",
  "v4.sources.code.CREATEUR_N_APPROUVE_PAS": "Séparation des tâches : qui a demandé la comparaison ne l’approuve pas ; une autre personne tranche.",
  "v4.sources.code.DROIT_NON_TENU": "Vous ne tenez pas le droit nécessaire sur ce projet.",
  "v4.sources.code.MODEL_NOT_GRANTED": "Un des modèles choisis n’est pas autorisé pour votre organisation.",
  "v4.sources.code.NOT_FOUND": "Introuvable dans ce projet.",
  "v4.sources.code.SELF_REVIEW_REFUSED": "Vous avez demandé cette comparaison : une autre personne la décide.",
  "v4.sources.code.STORAGE_UNAVAILABLE": "Le stockage des documents est indisponible pour le moment.",
  "v4.sources.code.VALIDATION_ERROR": "La saisie est incomplète ou invalide.",
  "v4.sources.code_historique": "Code historique : {{code}}.",
  "v4.sources.comparaison.adresse_invalide": "Cette adresse ne désigne pas une comparaison.",
  "v4.sources.comparaison.approuvee": "Comparaison approuvée.",
  "v4.sources.comparaison.approuver": "Approuver",
  "v4.sources.comparaison.avancement.echec": "Échec : aucun modèle n’a répondu.",
  "v4.sources.comparaison.avancement.echec_partiel": "Échec partiel : au moins un modèle n’a pas répondu.",
  "v4.sources.comparaison.avancement.en_cours": "Comparaison en cours : les modèles répondent.",
  "v4.sources.comparaison.avancement.terminee": "Comparaison terminée.",
  "v4.sources.comparaison.consommation": "Jetons : {{entree}} en entrée, {{sortie}} en sortie ; temps : {{temps}}",
  "v4.sources.comparaison.contenu_relu": "J’ai relu la question et toutes les réponses",
  "v4.sources.comparaison.decidee_approved": "Approuvée par {{qui}} le {{date}}. {{note}}",
  "v4.sources.comparaison.decidee_rejected": "Refusée par {{qui}} le {{date}} : {{note}}",
  "v4.sources.comparaison.decision": "Décision",
  "v4.sources.comparaison.decision_echec": "La décision n’a pas été enregistrée.",
  "v4.sources.comparaison.demandee_le": "Le",
  "v4.sources.comparaison.demandeur": "Demandée par",
  "v4.sources.comparaison.lecture_perimee": "Le contenu a changé depuis votre lecture : relisez-le.",
  "v4.sources.comparaison.non_decidable": "La décision est possible quand la comparaison est terminée.",
  "v4.sources.comparaison.note": "Note",
  "v4.sources.comparaison.note_aide": "Obligatoire pour refuser.",
  "v4.sources.comparaison.note_obligatoire": "Écrivez une note pour refuser.",
  "v4.sources.comparaison.panneau": "Réponses des modèles",
  "v4.sources.comparaison.question": "Question",
  "v4.sources.comparaison.quoi": "la comparaison",
  "v4.sources.comparaison.refus_distinct": "Refuser est la décision d’un validateur ; la personne qui a demandé la comparaison ne la décide pas.",
  "v4.sources.comparaison.refusee": "Comparaison refusée.",
  "v4.sources.comparaison.refuser": "Refuser",
  "v4.sources.comparaison.relance_echec": "La relance a échoué.",
  "v4.sources.comparaison.relancee": "Comparaison relancée : les modèles répondent de nouveau.",
  "v4.sources.comparaison.relancer": "Relancer la comparaison",
  "v4.sources.comparaison.reponse_attendue": "Réponse attendue.",
  "v4.sources.comparaison.reponse_de": "Réponse de {{modele}}",
  "v4.sources.comparaison.reponse_en_echec": "Ce modèle n’a pas répondu : {{erreur}}",
  "v4.sources.comparaison.retour": "Toutes les comparaisons",
  "v4.sources.comparaison.source": "Source",
  "v4.sources.comparaison.source_approval": "Décision n° {{id}}, section « {{section}} »",
  "v4.sources.comparaison.source_document": "Source de connaissance {{id}}, section « {{section}} »",
  "v4.sources.comparaison.titre": "Comparaison de réponses",
  "v4.sources.comparer.aucun_modele": "Aucun modèle n’est autorisé pour votre organisation.",
  "v4.sources.comparer.comparer": "Comparer",
  "v4.sources.comparer.echec": "La comparaison n’a pas pu être lancée.",
  "v4.sources.comparer.etat.echec": "En échec",
  "v4.sources.comparer.etat.en_cours": "En cours",
  "v4.sources.comparer.etat.terminee": "Terminée",
  "v4.sources.comparer.lancee": "Comparaison lancée.",
  "v4.sources.comparer.liste": "Comparaisons du projet",
  "v4.sources.comparer.minimum_deux": "Choisissez au moins deux modèles.",
  "v4.sources.comparer.modeles": "Modèles à comparer",
  "v4.sources.comparer.modeles_autorises": "Modèles autorisés",
  "v4.sources.comparer.nouvelle": "Nouvelle comparaison",
  "v4.sources.comparer.question": "Question posée à chaque modèle",
  "v4.sources.comparer.question_obligatoire": "Écrivez la question à poser aux modèles.",
  "v4.sources.comparer.titre": "Comparer des modèles",
  "v4.sources.comparer.vide": "Aucune comparaison dans ce projet.",
  "v4.sources.etat.chargement": "Chargement de {{quoi}}…",
  "v4.sources.etat.en_cours": "En cours…",
  "v4.sources.etat.erreur": "{{quoi}} : la lecture a échoué.",
  "v4.sources.etat.introuvable": "{{quoi}} : introuvable dans ce projet.",
  "v4.sources.etat.reessayer": "Réessayer",
  "v4.sources.etat.refus": "{{quoi}} : accès refusé.",
  "v4.sources.etat.vide": "Rien à afficher.",
  "v4.sources.raison.traitement_absent": "La relance de l’indexation n’est pas encore disponible sur cette plateforme : supprimez la source puis téléversez-la de nouveau pour la réindexer.",
  "v4.sources.sans_projet": "Choisissez d’abord un projet : cet écran porte sur un projet.",
  "v4.sources.source.adresse_invalide": "Cette adresse ne désigne pas une source.",
  "v4.sources.source.apercu": "Aperçu",
  "v4.sources.source.auteur": "Apportée par",
  "v4.sources.source.citation_orpheline": "Le passage cité ne se retrouve plus dans le document : la citation est orpheline depuis un changement.",
  "v4.sources.source.citations_conservees": "Les citations existantes de cette source sont conservées.",
  "v4.sources.source.confirmer_suppression": "Je confirme la suppression définitive de « {{nom}} »",
  "v4.sources.source.date": "Le",
  "v4.sources.source.document_indisponible": "Le document est indisponible dans le stockage.",
  "v4.sources.source.effet_citations": "Les citations existantes de cette source seront signalées comme orphelines.",
  "v4.sources.source.effet_confirmation": "Cochez la confirmation pour supprimer.",
  "v4.sources.source.effet_definitif": "Le document et ses vecteurs d’indexation sont supprimés définitivement.",
  "v4.sources.source.empreinte": "Empreinte (SHA-256)",
  "v4.sources.source.empreinte_absente": "Non calculée",
  "v4.sources.source.fiche": "Fiche de la source",
  "v4.sources.source.format_non_previsualisable": "Le format {{format}} ne se prévisualise pas : téléchargez le document.",
  "v4.sources.source.indexation.indexation_en_cours": "Indexation en cours.",
  "v4.sources.source.indexation.indexation_en_echec": "L’indexation a échoué : l’assistant ne peut pas la citer.",
  "v4.sources.source.indexation.nominal": "Indexée : l’assistant peut la citer.",
  "v4.sources.source.magasin_indisponible": "Le stockage des documents ne répond pas : l’aperçu reviendra quand il sera de nouveau joignable.",
  "v4.sources.source.motif": "Motif : {{motif}}",
  "v4.sources.source.nom": "Nom",
  "v4.sources.source.passage_localise": "Le passage cité est présent dans le document.",
  "v4.sources.source.quoi": "la source",
  "v4.sources.source.relance_echec": "L’indexation n’a pas pu être relancée.",
  "v4.sources.source.relance_en_file": "Indexation relancée (tentative {{n}}) : le traitement est en file, sa progression se suit ici.",
  "v4.sources.source.relance_indisponible.inconnue": "La relance de l’indexation est indisponible pour le moment.",
  "v4.sources.source.relance_indisponible.traitement_absent": "La relance de l’indexation n’est pas encore disponible sur cette plateforme : supprimez la source puis téléversez-la de nouveau pour la réindexer.",
  "v4.sources.source.relancee": "Indexation relancée.",
  "v4.sources.source.relancer": "Relancer l’indexation",
  "v4.sources.source.retour": "Toutes les sources du projet",
  "v4.sources.source.suppression": "Supprimer la source",
  "v4.sources.source.suppression_echec": "La suppression a échoué.",
  "v4.sources.source.supprimee": "Source supprimée.",
  "v4.sources.source.supprimer": "Supprimer définitivement",
  "v4.sources.source.telechargee": "Téléchargement lancé.",
  "v4.sources.source.telechargement_echec": "Le téléchargement a échoué.",
  "v4.sources.source.telecharger": "Télécharger",
  "v4.sources.source.tentatives": "Tentatives d’indexation : {{n}}",
  "v4.sources.source.titre": "Source de connaissance"
}
